import React, { memo, useMemo } from 'react';
import { useAppSelector } from '../../../redux/app';
import { useAllPositionProfits } from '../../../hooks/usePositionProfit';
import useAuth from '../../../hooks/useAuth';

const checkColor = (x) => {
  if (x === 0) return '!text-[#e5e5e5]';
  else if (x > 0) return '!text-[#28AFFF]';
  else if (x < 0) return '!text-[#EF4533]';
  else return '!text-[#e5e5e5]';
};

const getProfitPercent = (e, b) => {
  if (e && b) {
    return ((e / b) * 100).toFixed(2);
  }
  return '0.00';
};

const ProfitChange = memo(() => {
  const positions = useAppSelector(({ positions }) => positions?.positions);
  const swap = positions?.reduce((acc, curr) => acc + curr.swap, 0) ?? 0;
  return (
    <div>
      <div className="text-smalll !text-[#e5e5e5]">Profit</div>
      <EquityPercent swap={swap} />
      <Equity swap={swap} />
    </div>
  );
});

ProfitChange.displayName = 'ProfitChange';

const Equity = memo(({ swap }) => {
  const { profits, isCalculating, profitCount } = useAllPositionProfits();
  const balance = useAppSelector((state) => state.account?.account?.balance ?? 0);

  const totalProfit = Object.values(profits).reduce((acc, curr) => acc + curr.profit, 0);

  const { metatrader, activeAccount } = useAuth();

  const metaAccount = useMemo(() => {
    return metatrader.reduce((a, b) => {
      return {
        ...a,
        [b.id]: b
      };
    }, {});
  }, [metatrader]);

  const totalValue = totalProfit + swap;
  const isNegative = totalValue < 0;
  const absoluteValue = Math.abs(totalValue);

  return (
    <div className={`text-profit-dollar ${checkColor(((totalProfit + swap) / balance) * 100)}`}>
      {isNegative && '-'}
      {metaAccount[activeAccount]?.currency === 'USC' ? (
        <span>
          <span className="leading-[0px]">¢</span>
        </span>
      ) : (
        <span className="leading-[0px]">$</span>
      )}
      {absoluteValue.toFixed(2)}
    </div>
  );
});

Equity.displayName = 'Equity';

const EquityPercent = memo(({ swap }) => {
  const { profits, isCalculating, profitCount } = useAllPositionProfits();
  const balance = useAppSelector((state) => state.account?.account?.balance ?? 0);

  const totalProfit = Object.values(profits).reduce((acc, curr) => acc + curr.profit, 0);

  return (
    <div className={`text-profit-right ${checkColor((totalProfit / balance) * 100)}`}>
      <span>{getProfitPercent(totalProfit + swap, balance) > 0 ? '+' : ''}</span>
      {isNaN(getProfitPercent(totalProfit + swap, balance)) ? 0.0 : getProfitPercent(totalProfit + swap, balance)}
      <span className={`${checkColor((totalProfit + swap / balance) * 100)}`}>{` `}%</span>
    </div>
  );
});

EquityPercent.displayName = 'EquityPercent';

export default ProfitChange;
